/* eslint-disable */
import React from 'react';
import styles from './DevImport.module.css';

const ICON_BANG = <svg viewBox="0 0 24 24"><path d="M12 9v4M12 17h.01" /><circle cx="12" cy="12" r="9" /></svg>;

export function DevImportProgress({ phase, rowCount, error, onRetry, onClose }) {
  return (
    <div className={`${styles.dna} ${styles.overlay}`}>
      <div className={styles.progCard}>
        {!error && (
          <>
            <div className={styles.spinner} />
            <div className={styles.progTitle}>
              {phase === 'parsing' && 'Parsing Excel…'}
              {phase === 'classifying' && 'Analyzing rows against the database…'}
            </div>
            <div className={styles.progSub}>
              {phase === 'parsing' && 'Reading rows from the spreadsheet.'}
              {phase === 'classifying' && (
                rowCount
                  ? `Checking ${rowCount} row${rowCount === 1 ? '' : 's'} for conflicts. This can take up to 30 seconds for large files.`
                  : 'Checking for conflicts with existing developments.'
              )}
            </div>
          </>
        )}

        {error && (
          <>
            <div className={styles.errIcon}>{ICON_BANG}</div>
            <div className={styles.progTitle}>Import analysis failed</div>
            <div className={styles.progSub}>
              {String(error.message || error) || 'Unexpected error while classifying rows.'}
            </div>
            <div className={styles.progActions}>
              {onRetry && <button onClick={onRetry} className={styles.btnPrimary}>Retry</button>}
              {onClose && <button onClick={onClose} className={styles.btnGhost}>Cancel</button>}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
